var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.featureEnabled('ai_tools'))?_c('ai-agent-field-configurator',{attrs:{"configuration":_vm.configuration,"field-name":_vm.fieldName,"context-options":_vm.contextOptions,"trigger-options":_vm.triggerOptions,"ai-agent-options":_vm.aiAgentOptions}}):_c('feature-disabled-alert',{attrs:{"feature":"ai_tools"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }